import  { useContext }  from 'react'
import { ReservationContext } from '../redux/context/reservationProvider';

function useReservationContext() {
    return useContext(ReservationContext);
}

export default useReservationContext;